import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-file-modal',
  templateUrl: './view-file-modal.page.html',
  styleUrls: ['./view-file-modal.page.scss'],
})
export class ViewFileModalPage implements OnInit {

  public fileType: string;
  public fileSrc: string;

  constructor() { }

  ngOnInit() {
  }

}
